
import tir1360 from "../../images/svg/aracTypes/tir1360.svg" 
import kirkayak from "../../images/svg/aracTypes/kirkayak.svg" 
import teker10 from "../../images/svg/aracTypes/teker10.svg" 
import panelvan from "../../images/svg/aracTypes/panelvan.svg" 
import kamyonet from "../../images/svg/aracTypes/kamyonet.svg" 
import kamyonRomork from "../../images/svg/aracTypes/kamyonRomork.svg" 

const nakliyeFiyatHesaplamaAracOptions = [
    {
        id: 4,
        text: "Tır",
        value:"Tır",
        svg: tir1360
    },
    {
        id: 3,
        text: "Kırkayak",
        value:"Kırkayak",
        svg: kirkayak
    },
    {
        id: 5,
        text: "10 Teker Kamyon",
        value:"10 Teker Kamyon",
        svg: teker10
    },
    {
        id: 6,
        text: "6 Teker Kamyon",
        value:"6 Teker Kamyon",
        svg: teker10
    },
    {
        id: 7,
        text: "Kamyon Römork",
        value:"Kamyon Römork",
        svg: kamyonRomork
    },
    {
        id: 1,
        text: "Kamyonet",
        value:"Kamyonet",
        svg: kamyonet
    },
    {
        id: 2,
        text: "Panelvan",
        value:"Panelvan",
        svg: panelvan
    },
]

export default nakliyeFiyatHesaplamaAracOptions